import capitalize from "lodash/capitalize";
import { socialNetworkConnectionStatus } from "@/enums/social-network-enums";

export const SOCIAL_NETWORK_NAME_INSTAGRAM = "Instagram";

export const SOCIAL_NETWORK_LOGO_ICONS = {
  [SOCIAL_NETWORK_NAME_INSTAGRAM]: "instagram",
  Facebook: "facebook",
  Twitter: "twitter",
  X: "x",
  TikTok: "tiktok",
  YouTube: "youtube",
  LinkedIn: "linkedin",
  Pinterest: "pinterest",
  Snapchat: "snapchat",
  BlueSky: "bluesky",
  Threads: "ri:threads-fill",
  Reddit: "ri:reddit-fill",
};

const SOCIAL_NETWORK_DISPLAY_NAMES = {
  instagram: SOCIAL_NETWORK_NAME_INSTAGRAM,
  facebook: "Facebook",
  twitter: "Twitter",
  x: "X",
  tiktok: "TikTok",
  youtube: "YouTube",
  linkedin: "LinkedIn",
  pinterest: "Pinterest",
  snapchat: "Snapchat",
  bluesky: "BlueSky",
  threads: "Threads",
  reddit: "Reddit",
};

export const FALLBACK_NETWORK_ICON = "share-nodes";

export function socialNetworkDisplayName(socialNetworkName) {
  const key = String(socialNetworkName || "").trim().toLowerCase();
  return SOCIAL_NETWORK_DISPLAY_NAMES[key] || capitalize(key);
}

export function socialNetworkLogoIcon(socialNetworkName, fallbackIcon = FALLBACK_NETWORK_ICON) {
  return SOCIAL_NETWORK_LOGO_ICONS[socialNetworkDisplayName(socialNetworkName)] || fallbackIcon;
}

export const CREDENTIAL_CONNECT_SOCIAL_NETWORKS = ["BlueSky"];

export const OAUTH_CONNECT_SOCIAL_NETWORKS = ["Instagram", "Twitter", "LinkedIn", "TikTok", "YouTube", "Facebook", "Pinterest", "Reddit"];

export const CONNECT_METHOD_CREDENTIAL = "credential";
export const CONNECT_METHOD_OAUTH = "oauth";
export const CONNECT_METHOD_HANDLE = "handle";

export function connectMethodFor(socialNetworkName) {
  if (CREDENTIAL_CONNECT_SOCIAL_NETWORKS.includes(socialNetworkName)) {
    return CONNECT_METHOD_CREDENTIAL;
  }
  if (OAUTH_CONNECT_SOCIAL_NETWORKS.includes(socialNetworkName)) {
    return CONNECT_METHOD_OAUTH;
  }
  return CONNECT_METHOD_HANDLE;
}

export const IMPORT_STATUS_POLL_INTERVAL_MS = 3000;

export const socialNetworkStatusMap = {
  [socialNetworkConnectionStatus.CONNECTED]: "Connected",
  [socialNetworkConnectionStatus.DISCONNECTED]: "Disconnected",
  [socialNetworkConnectionStatus.NEVER_CONNECTED]: "Never connected",
  [socialNetworkConnectionStatus.BROKEN_CONNECTION]: "Broken connection",
  [socialNetworkConnectionStatus.MANUAL_CONNECTION]: "Manual connection",
  [socialNetworkConnectionStatus.INACTIVE]: "Inactive",
};
